module.exports = __webpack_public_path__ + "img/banner_teamWork.e334c27d.jpg";